import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Brochure from "../../Assets/royalbro.pdf";
import { Link } from "react-router-dom";
import "../../App.css";

const Footer = () => {
  const [isVisible, setIsVisible] = useState({
    0: false, // State for column 1
    1: false, // State for column 2
    2: false, // State for column 3
    3: false, // State for column 4
  });

  const toggleVisibility = (columnIndex) => {
    setIsVisible((prevState) => ({
      ...prevState,
      [columnIndex]: !prevState[columnIndex],
    }));
  };

  return (
    <footer>
      <Container fluid className="text-white footerimg2">
        <Row className="p-3">
          <Col lg={3}>
            <h6 className="py-3">Immediate Contact</h6>
            <div className="lightTxt py-2">Visit Us (09:00AM to 06:00PM)</div>
            <span className="d-block d-sm-inline-block">
              <i className="fa-solid fa-mobile text-white"></i>
              <Link
                to="tel:0000-000-000"
                className="text-green text-decoration-none"
              >
                {" "}
                +91-9890-099-992
              </Link>
            </span>
            <p className="pt-1 lightTxt">
              ROYAL GREEN HOUSE CONSTRUCTION (I) PVT LTD 
              Royal Green Factory, Nandgaon, Satara, Maharashtra, 415107
            </p>
            {/* <a href={Brochure} target="_blank" rel="noopener noreferrer">
              <button className="text-uppercase text-center bgGreen btn-orange text-white fw-bold">
                <i className="fa-solid fa-download text-white"></i> Download
                Brochure
              </button>
            </a> */}
          </Col>
          <Col lg={3}>
            <h6 className="py-3">Company</h6>
            <div className="py-1">
              <Link to="/About" className="text-decoration-none lightTxt">
                About us
              </Link>
            </div>
            {/* <div className="py-1">
              <Link
                to="/CustomerReview"
                className="text-decoration-none lightTxt"
              >
                Customer Review
              </Link>
            </div> */}
            <div className="py-1">
              <Link to="/contact" className="text-decoration-none lightTxt">
                Contact Us
              </Link>
            </div>
          </Col>
          <Col lg={3}>
            <h6 className="py-3">Project</h6>
            {/* <div className="py-1">
              <Link to="/OurProjects" className="text-decoration-none lightTxt">
                Our Projects
              </Link>
            </div> */}
            <div className="py-1">
              <Link to="/Gallery" className="text-decoration-none lightTxt">
                Gallery
              </Link>
            </div>
            <div className="py-1">
              <Link
                to="/Insulator_fittings_and_accessories"
                className="text-decoration-none lightTxt"
              >
                Products
              </Link>
            </div>
          </Col>
          {/* <Col lg={3}>
            <h6 className="py-3">Services</h6>
            <div className="py-1">
              <Link to="/Nvph" className="text-decoration-none lightTxt">
                Naturally Ventilated Polyhouse
              </Link>
            </div>
            <div className="py-1">
              <Link
                to="/ClimateControlled"
                className="text-decoration-none lightTxt"
              >
                Climate Control Polyhouse (Fan & Pad)
              </Link>
            </div>
            <div className="py-1">
              <Link to="/nftAframe" className="text-decoration-none lightTxt">
                NFT A-Frame System
              </Link>
            </div>
            <div className="py-1">
              <Link to="/NftFlatbed" className="text-decoration-none lightTxt">
                NFT Flatbed System
              </Link>
            </div>
            <div className="py-1">
              <Link to="/DWC" className="text-decoration-none lightTxt">
                DWC System
              </Link>
            </div>
            <div className="py-1">
              <Link to="/DutchBucket" className="text-decoration-none lightTxt">
                Dutch Bucket/Bato Bucket System
              </Link>
            </div>

            <div className="py-1">
              <Link to="/Grow_Slab" className="text-decoration-none lightTxt">
                Grow Slab System
              </Link>
            </div>
            <div className="py-1">
              <Link to="/Grow_bag" className="text-decoration-none lightTxt">
                Grow Bag System
              </Link>
            </div>
          </Col> */}
        </Row>

        {/* <Row>
          {columnLinks.map((links, colIndex) => (
            <Col lg={3} md={6} sm={12} key={colIndex}>
              <div className="text-center">
                {links.map((city, index) => (
                  <div key={index} className="py-1 text-justify">
                    <Link
                      to="/contact"
                      className="text-decoration-none lightTxt"
                    >
                      Commercial Hydroponic Farm at {city}
                    </Link>
                  </div>
                ))}
                {isVisible[colIndex] && additionalColumns[colIndex] && (
                  <>
                    {additionalColumns[colIndex].map((city, index) => (
                      <div key={index} className="py-1 text-justify">
                        <Link
                          to="/contact"
                          className="text-decoration-none lightTxt"
                        >
                          Commercial Hydroponic Farm at {city}
                        </Link>
                      </div>
                    ))}
                    <button
                      onClick={() => toggleVisibility(colIndex)}
                      className="btn btn-light mt-3"
                    >
                      View Less
                    </button>
                  </>
                )}
                {!isVisible[colIndex] && additionalColumns[colIndex] && (
                  <button
                    onClick={() => toggleVisibility(colIndex)}
                    className="btn btn-light mt-3"
                  >
                    View More
                  </button>
                )}
              </div>
            </Col>
          ))}
        </Row> */}

        <Row className="pt-100">
          <Col className="text-center m-10">
            <p>GSTIN: 27AACHR0745D1ZK</p>
            <p>CIN :U74900PN2014PTC152556</p>
            <h6>Royal Green Energy</h6>
            <p>
              Royal Green Factory, Nandgaon, Satara, Maharashtra, 415107
            </p>
          </Col>
        </Row>
        <Row>
          <Col className="p-5">
            <Row>
              <Col lg={3} className="px-2 text-center">
                <Link
                  to="/WorkWithus"
                  className="lightTxt text-decoration-none"
                >
                  Work with us
                </Link>
              </Col>
              <Col lg={3} className="px-2 text-center">
                <Link to="/Terms" className="lightTxt text-decoration-none">
                  Terms & Condition
                </Link>
              </Col>
              <Col lg={3} className="px-2 text-center">
                <Link to="/Privacy" className="lightTxt text-decoration-none">
                  Privacy Policy
                </Link>
              </Col>
              <Col lg={3} className="px-2 text-center">
                <Link to="/Refund" className="lightTxt text-decoration-none">
                  Refund Policy
                </Link>
              </Col>
            </Row>
          </Col>
          <Col className="text-center p-5 lightTxt">
            <span>
              Visitors :{" "}
              <a
                href="https://www.hitwebcounter.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://hitwebcounter.com/counter/counter.php?page=21462937&style=0002&nbdigits=7&type=page&initCount=0"
                  Alt="Free Tools"
                  title="Free Counter"
                  alt="web counter"
                  border="0"
                />
              </a>{" "}
            </span>
          </Col>
        </Row>
        <Row>
          <Col className="text-center p-2">
            <span>
              @{new Date().getFullYear()} Royal Green Energy Pvt. Ltd., All
              rights Reserved
            </span>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
